export function twoPointForm(point1, point2) {
    const m = slope(point1, point2);
    return (x) => m * (x - point1.x) + point1.y;
}
export function slope(point1, point2) {
    return (point2.y - point1.y) / (point2.x - point1.x);
}
export function point(x, y) {
    return { x: x, y: y };
}
